import { THEME_VARIANTS } from 'core/components/theme/theme-variant';

// Pages whose content sits in a narrow centered column, leaving room for scenery on either side.
export const GUTTER_ARTWORK_PAGES = ['/portal', '/quote', '/search'];

// Branch-brand art for the new look only: the mutuals' own illustrations aren't approved yet, and classic never shows it.
export const shouldShowGutterArtwork = ({ isLoggedIn, themeVariant, isBranchBrand, isArtworkPage }) =>
  isLoggedIn && themeVariant === THEME_VARIANTS.RESKIN && isBranchBrand && isArtworkPage;
